var exports = {
  "iE": "xaee3c4fa--b97ac4--wrapper",
  "DD": "xaee3c4fa--b97ac4--title",
  "Ak": "xaee3c4fa--b97ac4--scrolling-wrapper",
  "X4": "xaee3c4fa--b97ac4--scrolling-inner-wrapper",
  "gJ": "xaee3c4fa--b97ac4--slide-wrapper",
};

module.exports = exports;
